export default __webpack_public_path__ + "static/media/banner1.10ca9fe6.webp";